import '../css/app.css';

import 'lazysizes';

import Swup from 'swup';
import SwupGiaPlugin from '@swup/gia-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import loadComponents from 'gia/loadComponents';

import components from './components';

loadComponents(components);

window.loadComponents = loadComponents;
window.components = components;


import Cart from './vue-components/Cart.vue';
import AddToCart from './vue-components/AddToCart.vue';
import CartMenu from './vue-components/CartMenu.vue';

import mitt from 'mitt';

import { createApp } from 'vue';

let options = [
  {
    from: '(.*)',
    to: '(.*)',
    in: function(next, context) {
      gsap.to('#swup', {
        opacity: 1,
        duration: 0.5,
        onComplete: function() {
          // gsap.to('.c--overlay', 0.2, {
          //   opacity:0
          // });
          next();
        }
      })
    },
    out: function(next, context) {

      // eventbus.emit("leavingPage", {url: swup.getCurrentUrl()});
      gsap.to('#swup', {
        opacity: 0,
        duration: 0.2,
        onComplete: function() {
          gsap.to(window, 0, {
            scrollTo: 0
          });

          // gsap.to('.c--overlay', 0.2, {
          //   opacity:1
          // });

          next();
        }
      })

    }
  }
];


function initVue() {
  if (document.querySelector('#app-cart')) {
    const app = createApp({
      compilerOptions: {
        delimiters: ['${', '}']
      },
      components: {
        Cart
      },
      data() {
        return {}
      }
    });
    // app.use(pinia);
    app.provide('emitter', emitter);

    app.mount('#app-cart');
  }

  if (document.querySelector('.app-cart-menu')) {
    document.querySelectorAll('.app-cart-menu').forEach(function(el) {
      const app = createApp({
        compilerOptions: {
          delimiters: ['${', '}']
        },
        components: {
          CartMenu
        },
        data() {
          return {}
        }
      });
      // app.use(pinia);
      app.provide('emitter', emitter);

      app.mount(el);
    })
    //

  }

  if (document.querySelector('.app-add-to-cart')) {
    document.querySelectorAll('.app-add-to-cart').forEach(function(el) {
      const app = createApp({
        compilerOptions: {
          delimiters: ['${', '}']
        },
        components: {
          AddToCart
        },
        data() {
          return {}
        }
      });
      app.provide('emitter', emitter);

      app.mount(el);
    });
  }
};


const emitter = mitt()

initVue();


const swup = new Swup({
  plugins: [
    new SwupGiaPlugin({components: components, firstLoad: true}),
    new SwupJsPlugin(options)
  ]
});